import { staffMenuSectionAllowed } from "@/utils/staffAccess.js";

export const CUSTOMER_PROFILE_DEFAULT_SECTION = "purchases";

export const CUSTOMER_PROFILE_MENU = [
    { id: "purchases", label: "Mes achats", icon: "package" },
    { id: "favorites", label: "Mes Favoris", icon: "heart-filled" },
    { id: "addresses", label: "Mes adresses", icon: "map-pin" },
    { id: "profile", label: "Mon profil", icon: "user" },
    { id: "password", label: "Mot de passe", icon: "lock" }
];

export const ADMIN_PROFILE_DEFAULT_SECTION = "orders";

export const ADMIN_PROFILE_MENU = [
    { id: "orders", label: "Gérer les commandes", icon: "clipboard-list" },
    { id: "products", label: "Gérer les produits", icon: "box" },
    { id: "lots", label: "Gérer les lots", icon: "layers" },
    { id: "customers", label: "Gérer les clients", icon: "users" },
    { id: "carts", label: "Gérer les paniers", icon: "cart" },
    { id: "voeux", label: "Gérer les « J'aime »", icon: "heart-filled" },
    { id: "shops", label: "Gérer les magasins", icon: "store" },
    { id: "advertisements", label: "Gérer les publicités", icon: "eye" },
    { id: "reviews", label: "Gérer les avis", icon: "star" },
    { id: "employees", label: "Gérer les employés", icon: "users" },
    { id: "legal", label: "Informations légales", icon: "file-text" },
    { id: "profile", label: "Mon profil", icon: "user" },
    { id: "password", label: "Mot de passe", icon: "lock" }
];

export function staffProfileMenuForRole(role) {
    return ADMIN_PROFILE_MENU.filter((item) => staffMenuSectionAllowed(role, item.id));
}

export const ACCOUNT_MENU_CART = { id: "cart", label: "Mon panier", icon: "cart" };
export const ACCOUNT_MENU_LOGOUT = { id: "logout", label: "Déconnexion", icon: "log-out" };
export const ACCOUNT_MENU_LOGIN = { id: "login", label: "Connexion", icon: "log-in" };
export const ACCOUNT_MENU_REGISTER = { id: "register", label: "Créer un compte", icon: "user-plus" };

export const HEADER_NAV_ITEMS = {
    catalogue: { label: "Catalogue", icon: "store" },
    nouveautes: { label: "Nouveautés", icon: "star" },
    arrives: { label: "Restockage", icon: "truck" },
    contact: { label: "Contact", icon: "mail" },
    cart: { label: "Panier", icon: "cart" },
    purchases: { label: "Mes achats", icon: "package" }
};
